import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import { api } from "../lib/api";
import { Card } from "../components/ui/card";
import { Avatar, AvatarFallback, AvatarImage } from "../components/ui/avatar";
import { Heart } from "lucide-react";

export default function Matches() {
  const [matches, setMatches] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/matches").then(({ data }) => setMatches(data)).finally(() => setLoading(false));
  }, []);

  return (
    <div className="min-h-screen bg-[#FFFDF9]">
      <Navbar />
      <main className="max-w-4xl mx-auto px-4 py-8">
        <h1 className="font-serif text-3xl sm:text-4xl font-bold text-[#2C2623] mb-2">Your matches</h1>
        <p className="text-[#6E655F] mb-8">People who like you back. Say hi.</p>

        {loading ? (
          <div className="text-[#6E655F]">Loading…</div>
        ) : matches.length === 0 ? (
          <Card className="p-12 text-center rounded-3xl border-[#E8DEC8] bg-white">
            <Heart className="w-12 h-12 text-[#E88796] mx-auto mb-4" />
            <h3 className="font-serif text-2xl font-semibold mb-2">No matches yet</h3>
            <p className="text-[#6E655F] mb-6">Head to Discover and start liking profiles.</p>
            <Link to="/discover" data-testid="matches-go-discover-link"
              className="inline-block px-6 py-3 rounded-full bg-[#D95D39] hover:bg-[#C24C29] text-white font-medium">
              Discover people
            </Link>
          </Card>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {matches.map((m) => (
              <Link key={m.match_id} to={`/messages/${m.match_id}`} data-testid={`match-card-${m.match_id}`}>
                <Card className="p-4 rounded-2xl border-[#E8DEC8] bg-white hover:shadow-lg transition-shadow cursor-pointer">
                  <div className="flex items-center gap-4">
                    <Avatar className="w-16 h-16 ring-2 ring-[#FFF0EC]">
                      <AvatarImage src={m.user.picture} />
                      <AvatarFallback className="bg-[#D95D39] text-white text-xl">{m.user.name?.[0]}</AvatarFallback>
                    </Avatar>
                    <div className="flex-1 min-w-0">
                      <div className="font-serif text-lg font-semibold text-[#2C2623]">{m.user.name}</div>
                      <div className="text-sm text-[#6E655F] truncate">
                        {m.last_message?.text || "Say hello ✨"}
                      </div>
                    </div>
                  </div>
                </Card>
              </Link>
            ))}
          </div>
        )}
      </main>
    </div>
  );
}
